import { render, staticRenderFns } from "./HotbSignatureSection.vue?vue&type=template&id=4b83f00b&scoped=true&"
import script from "./HotbSignatureSection.vue?vue&type=script&lang=js&"
export * from "./HotbSignatureSection.vue?vue&type=script&lang=js&"
import style0 from "./HotbSignatureSection.vue?vue&type=style&index=0&id=4b83f00b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83f00b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b83f00b')) {
      api.createRecord('4b83f00b', component.options)
    } else {
      api.reload('4b83f00b', component.options)
    }
    module.hot.accept("./HotbSignatureSection.vue?vue&type=template&id=4b83f00b&scoped=true&", function () {
      api.rerender('4b83f00b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/HotbSignatureSection.vue"
export default component.exports